import * as React from 'react'

import { listToObj } from 'core/utils/common'

const useObjFromList = <T = any>(list: T[], keyName: string) => {
  return React.useMemo(() => listToObj<T>(list, keyName), [keyName, list])
}

export default useObjFromList
